import React from 'react';
import { Select } from 'antd';

// Generic single-select filter dropdown used for position/team/depth chart filters
const FilterDropdown = ({ placeholder, options, value, onChange }) => (
  <Select
    placeholder={placeholder}
    value={value || undefined}
    onChange={(v) => onChange(v ?? null)}
    style={{ width: 160, marginBottom: 16, marginLeft: 8 }}
    allowClear
  >
    {options.map((opt) => <Select.Option key={opt} value={opt}>{opt}</Select.Option>)}
  </Select>
);

export default FilterDropdown;
